export function CollaboratorAccessWarning() {
  return (
    <>
      Collaborators will be able to view and edit{' '}
      <strong>all client and entity information</strong> for the households that
      they have access to.
    </>
  );
}
